// extracted by mini-css-extract-plugin
export default {"defaultContainer":"MobileView_defaultContainer__2ISXv"};